import { render, staticRenderFns } from "./WatermarksFooter.vue?vue&type=template&id=06df82b4&lang=html&"
import script from "./WatermarksFooter.vue?vue&type=script&lang=ts&"
export * from "./WatermarksFooter.vue?vue&type=script&lang=ts&"
import style0 from "./WatermarksFooter.vue?vue&type=style&index=0&id=06df82b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports